"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "storo": {
    "9fe54424": [{
      "hkey": "e62f8c61",
      "slug": "lodrone-darzo",
      "name": "Lodrone-Darzo",
      "primary": true,
      "skipSearch": false
    }],
    "darzo": [{
      "hkey": "e62f8c61",
      "slug": "lodrone-darzo",
      "name": "Lodrone-Darzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "c00837c6": [{
      "hkey": "e62f8c61",
      "slug": "lodrone-darzo",
      "name": "Lodrone-Darzo",
      "primary": true,
      "skipSearch": false
    }],
    "lodrone": [{
      "hkey": "e62f8c61",
      "slug": "lodrone-darzo",
      "name": "Lodrone-Darzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "storo"
    }]
  }
};
exports["default"] = _default;